import React from "react";
import { IPetsyHelperTextsProps } from "./PetsyHelperTexts.types";
import {
  Icon,
  IconSize,
  IconColorStyle
} from "@adaptis/flow-components";
import _ from "../../imports/lodash-imports";
import "./PetsyHelperTexts.scss";

export default function PetsyTableGreenBoxes(props: IPetsyHelperTextsProps) {


  return (
    <div className={`flc_petsy-feature-label-group petsy-helper-texts ${props.isHaveLineBottom ? 'line-bottom' : ""}  ${props.className ? props.className : ""}`}>
      <div className="helper-item">
        <div className="flc_feature-label">
          <Icon
            className='me-2'
            src={"/images/icons/check-green-bg.svg"}
            colorStyle={IconColorStyle.Success}
            size={IconSize.ExtraSmall}
          />
        </div>
        <span className="">{props.content}</span>
      </div>

    </div>
  );
}
